<template>
  <div>
    <v-radio-group v-model="studentKMITL" row v-bind:rules="inputRules">
      <v-radio value="firstTime" :label="$t('info_card.first_time')" />
      <v-radio value="reEntry" :label="$t('info_card.second_time')" />
    </v-radio-group>
    <v-row
      ><v-col cols="12" sm="6">
        <div v-if="studentKMITL === 'reEntry'">
          <h6>{{ $t("info_card.old_studentID") }}</h6>
          <v-text-field
            v-model="oldKMITLStudentID"
            v-bind:rules="inputRules"
            density="compact"
            variant="outlined"
          /></div
      ></v-col>
    </v-row>
  </div>
</template>

<script>
import validator from "@/helper/validator";
export default {
  name: "FirstEncounter",
  props: {
    modelValue: Object,
  },
  data: () => ({
    inputRules: [validator.required],
  }),
  computed: {
    studentKMITL: {
      get() {
        return this.modelValue.studentKMITL;
      },
      set(value) {
        this.$emit("update:modelValue", {
          studentKMITL: value,
          oldKMITLStudentID: this.oldKMITLStudentID,
        });
      },
    },
    oldKMITLStudentID: {
      get() {
        return this.modelValue.oldKMITLStudentID;
      },
      set(value) {
        this.$emit("update:modelValue", {
          oldKMITLStudentID: value,
          studentKMITL: this.studentKMITL,
        });
      },
    },
  },
};
</script>
